import { helper, http } from "../util";

const controller = "invoice";

//types
export const RESET_STORE = "RESET_STORE";
export const REQUEST_INVOICE = "REQUEST_INVOICE";
export const RECIEVE_INVOICE = "RECIEVE_INVOICE";

//methods
const _resetStore = () => ({ type: RESET_STORE });
export const resetStore = () => (dispatch) => dispatch(_resetStore());

const requestItem = () => ({ type: REQUEST_INVOICE });
const recieveItem = (payload) => ({ type: RECIEVE_INVOICE, payload });
export const get = (id) => (dispatch) => {
    dispatch(requestItem());

    return dispatch(() =>
        http
            .get(helper.getApiPath(controller, "GetByCode"), id)
            .then((data) => dispatch(recieveItem(data)))
    );
};
